import Link from "next/link";

const people = [
  {
    name: "David Head",
    imageUrl:
      "https://chmqmeyyaiwfybqgcdoy.supabase.co/storage/v1/object/public/users/41ade6fa-b654-4610-9d83-ac703e2c4952/davids-head-avatar-dm.jpg",
  },
];
const activityItems = [
  {
    id: 1,
    person: people[0],
    date: "2023-2-13",
    update: "Released Showspace v0 beta to users",
  },
  {
    id: 2,
    person: people[0],
    date: "2023-2-15",
    update:
      "Integrated GPT API to generate project drafts, short descriptions, and titles",
  },
  {
    id: 3,
    person: people[0],
    date: "2023-2-25",
    update: "Added new profile section on portfoio page",
    learnMore: "https://showspace.so/p/571",
  },
  {
    id: 4,
    person: people[0],
    date: "2023-3-1",
    update:
      "Upgraded AI to the new ChatGPT model, which increased response quality, and speed by ~8x. Also updated to include placeholder metrics, more accurate example team breakdowns, and diverse team names.",
    learnMore: "https://showspace.so/p/667",
  },
  {
    id: 5,
    person: people[0],
    date: "2023-3-28",
    update: "Added YouTube embed functionality.",
  },
  {
    id: 6,
    person: people[0],
    date: "2023-3-29",
    update:
      "Updated rich editor styling. Added image lightbox to all images by default. Improved page loading on project pages.",
  },
];

export default function ChangeLog() {
  return (
    <div className="mx-auto mt-12 max-w-xl px-6">
      <h1 className="mb-8 text-center">Changelog</h1>
      <ul role="list" className="divide-y divide-gray-200">
        {activityItems.map((activityItem) => (
          <li key={activityItem.id} className="py-4">
            <div className="flex space-x-3">
              <img
                className="h-6 w-6 rounded-full"
                src={activityItem.person.imageUrl}
                alt=""
              />
              <div className="flex-1 space-y-1">
                <div className="flex items-center justify-between">
                  <h3 className="mt-0 text-sm font-medium">
                    {activityItem.person.name}
                  </h3>
                  <p className="text-sm text-gray-500">{activityItem.date}</p>
                </div>
                <p className="text-sm text-gray-500">{activityItem.update}</p>

                <div>
                  {activityItem.learnMore === undefined ? null : (
                    <Link
                      href={activityItem.learnMore}
                      className="text-sm text-indigo-500"
                    >
                      Learn More
                    </Link>
                  )}
                </div>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
